module.exports = __webpack_public_path__ + "img/1.5f4eae2e.png";